import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class ItemRoomTypeStore {

    // Properties

    // Modal Create/Update Properties

    @observable showItemRoomTypeModal = false;
    @observable itemRoomTypeTitle = '';

    @observable itemRoomTypes = [];
    @observable itemRoomTypeId = 0;
    @observable roomTypeId = 0;
    @observable roomTypeName = '';
    @observable taskID = 0;
    @observable taskName = '';
    @observable itemRoomTypeTextButton = 'Create';

    // Modal Search Item Properties

    @observable showItemSearchModal = false;
    @observable items = [];
    @observable itemFilter = [];
    @observable itemSearchValue = '';

    // Modal Search Room Type Properties

    @observable showRoomTypeSearchModal = false;
    @observable roomTypes = [];
    @observable roomTypeFilter = [];
    @observable roomTypeSearchValue = '';

    // Helper Properties

    @observable itemRoomTypeListLoading = false;
    @observable itemRoomTypeModalLoading = false;

    // Initialization

    @action initItemRoomType() {
        this.itemRoomTypeListLoading = true;

        ApiCaller.RoomSetups.apiGetItemRoomTypes().then(itemRoomTypeResponses => {
            if (!itemRoomTypeResponses.isError) {
                this.itemRoomTypes = itemRoomTypeResponses.data;

                ApiCaller.Item.apiGetLastChilds().then((itemResponses) => {
                    if (!itemResponses.isError) {
                        this.items = itemResponses;
                        this.itemFilter = this.items;
                    } else {
                        this.items = [];
                        this.itemFilter = this.items;
                    }

                    ApiCaller.RoomSetups.apiGetRoomTypes().then((roomTypeResponses) => {
                        if (!roomTypeResponses.isError) {
                            this.roomTypes = roomTypeResponses.data;
                            this.roomTypeFilter = this.roomTypes;
                        } else {
                            this.roomTypes = [];
                            this.roomTypeFilter = this.roomTypes;
                        }
    
                        this.itemRoomTypeListLoading = false;
                    });
                });
            } else {
                this.itemRoomTypes = [];
                this.itemRoomTypeListLoading = false;
            }
        });
    }

    @action initCreateItemRoomType() {
        this.itemRoomTypeTitle = 'Create Item Room Type';

        this.itemRoomTypeId = 0;
        this.roomTypeId = 0;
        this.roomTypeName = '';
        this.taskID = 0;
        this.taskName = '';

        this.itemRoomTypeTextButton = 'Create';
        this.showItemRoomTypeModal = true;
    }

    @action initUpdateItemRoomType(itemRoomTypeId) {
        this.itemRoomTypeModalLoading = true;
        this.itemRoomTypeTitle = 'Update Item Room Type';
        this.itemRoomTypeTextButton = 'Update';
        this.showItemRoomTypeModal = true;

        ApiCaller.RoomSetups.apiGetItemRoomTypeById(itemRoomTypeId).then(itemRoomTypeResponse => {
            if (!itemRoomTypeResponse.isError) {
                if (itemRoomTypeResponse.data) {
                    this.itemRoomTypeId = itemRoomTypeResponse.data.itemRoomTypeId;
                    this.roomTypeId = itemRoomTypeResponse.data.roomTypeId;
                    this.roomTypeName = itemRoomTypeResponse.data.roomTypeName;
                    this.taskID = itemRoomTypeResponse.data.taskID;
                    this.taskName = itemRoomTypeResponse.data.taskName;
                } else {
                    this.itemRoomTypeId = 0;
                    this.roomTypeId = 0;
                    this.roomTypeName = '';
                    this.taskID = 0;
                    this.taskName = '';
                }
            } else {
                this.itemRoomTypeId = 0;
                this.roomTypeId = 0;
                this.roomTypeName = '';
                this.taskID = 0;
                this.taskName = '';
            }

            this.itemRoomTypeModalLoading = false;
        });
    }

    // Transaction - Item

    @action searchItem() {
        this.itemFilter = this.items.filter(room => {
            let taskName = room.taskName.toLowerCase();
            return taskName.indexOf(this.itemSearchValue.toLowerCase()) !== -1;
        });
    }

    @action searchItemSelected(taskID) {
        const item = this.items.find(x => x.taskId === taskID);
        this.taskID = taskID;
        this.taskName = item.taskName;
    }

    // Transaction - Room Type

    @action searchRoomType() {
        this.roomTypeFilter = this.roomTypes.filter(roomType => {
            let roomTypeName = roomType.roomTypeName.toLowerCase();
            return roomTypeName.indexOf(this.roomTypeSearchValue.toLowerCase()) !== -1;
        });
    }

    @action searchRoomTypeSelected(roomTypeId) {
        const roomType = this.roomTypes.find(x => x.roomTypeId === roomTypeId);
        this.roomTypeId = roomTypeId;
        this.roomTypeName = roomType.roomTypeName;
    }

    // Transaction Item Room Type

    @action createItemRoomType() {
        this.itemRoomTypeModalLoading = true;

        const newItemRoomType = {
            'itemRoomTypeId': 0,
            'roomTypeId': this.roomTypeId,
            'taskID': this.taskID
        };

        return ApiCaller.RoomSetups.apiCreateItemRoomType(newItemRoomType).then((createItemRoomTypeResponse) => {
            this.itemRoomTypeModalLoading = false;
            
            if (!createItemRoomTypeResponse.isError) {
                this.showItemRoomTypeModal = false;
            }

            return createItemRoomTypeResponse;
        });
    }

    @action updateItemRoomType() {
        this.itemRoomTypeModalLoading = true;

        const updateItemRoomType = {
            'itemRoomTypeId': this.itemRoomTypeId,
            'taskID': this.taskID,
            'roomTypeId': this.roomTypeId,
        };

        return ApiCaller.RoomSetups.apiUpdateItemRoomType(this.itemRoomTypeId, updateItemRoomType).then((updateItemRoomTypeResponse) => {
            this.itemRoomTypeModalLoading = false;

            if (!updateItemRoomTypeResponse.isError) {
                this.showItemRoomTypeModal = false;
            }

            return updateItemRoomTypeResponse;
        });
    }

    @action deleteItemRoomType(itemRoomTypeId) {
        this.itemRoomTypeListLoading = true;

        return ApiCaller.RoomSetups.apiDeleteItemRoomTypeById(itemRoomTypeId).then((deleteItemRoomTypeResponse) => {
            this.itemRoomTypeListLoading = false;

            if (!deleteItemRoomTypeResponse.isError) {
                this.initItemRoomType();
            }

            return deleteItemRoomTypeResponse;
        });
    }

    // SET Properties

    @action setShowItemRoomTypeModal(value) {
        this.showItemRoomTypeModal = value;
    }

    @action setShowItemSearchModal(value) {
        this.showItemSearchModal = value;
    }

    @action setShowRoomTypeSearchModal(value) {
        this.showRoomTypeSearchModal = value;
    }

    @action setItemSearchValue(value) {
        this.itemSearchValue = value
    }

    @action setRoomTypeSearchValue(value) {
        this.roomTypeSearchValue = value
    }
}

export default new ItemRoomTypeStore()